import { FC } from "react";
import { ReportSectionFieldsFragment } from "app/api/graph/types";
import { HtmlContent } from "app/component/util/HtmlContent";

type Props = { section: ReportSectionFieldsFragment };

export const SectionContent: FC<Props> = ({ section }) =>
    section ? <HtmlContent className="formatted-content" html={section?.content ?? ""} /> : null;
